module.exports = __webpack_public_path__ + "a1a93b8edcfa81eaee73d95a2d4e532e.webm";


//////////////////
// WEBPACK FOOTER
// ./assets/tutorials/translate.webm
// module id = zFr+
// module chunks = 0